import {RUTUBE_HOST} from 'components/VideoRutube/constants';
import {TVideoId} from 'components/VideoRutube/type';

export const getPreviewSrc = (videoId: TVideoId) => `${RUTUBE_HOST}/api/video/${videoId}/thumbnail/?redirect=1`;
